var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "height": "auto",
      "background-color": "white",
      "margin": "5px 5px 20px 5px",
      "padding-bottom": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "3%"
    }
  }, [_c('el-row', {
    staticStyle: {
      "padding": "20px 0"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('span', [_vm._v("组织架构")]), _vm._v(" "), _c('el-cascader', {
    staticStyle: {
      "margin-left": "10px",
      "width": "300px"
    },
    attrs: {
      "clearable": "",
      "collapse-tags": "",
      "props": _vm.props
    },
    model: {
      value: (_vm.condition.organize_ids),
      callback: function($$v) {
        _vm.$set(_vm.condition, "organize_ids", $$v)
      },
      expression: "condition.organize_ids"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "85px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Find
    }
  }, [_vm._v("\n                        查询")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "width": "85px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Update
    }
  }, [_vm._v("\n                        更新")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('download-excel', {
    staticClass: "export-excel-wrapper",
    staticStyle: {
      "top": "100px",
      "width": "5%"
    },
    attrs: {
      "fields": _vm.download_excel,
      "name": "员工基本信息表",
      "fetch": _vm.ExportForm
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "85px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    }
  }, [_vm._v("\n                            导出")])], 1)], 1)], 1)], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 3%",
      "margin-top": "30px"
    }
  }, [_c('el-row', [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "header-cell-style": {
        background: '#d3eae2',
        color: '#000000'
      },
      "height": "574px",
      "row-class-name": _vm.tableRowClassName,
      "data": _vm.tableData,
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "序号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope_1) {
        return [_vm._v("\n                            " + _vm._s(scope_1.$index + 1) + "\n                        ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "organize_name",
      "align": "center",
      "label": "架构"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "70岁（含）超龄员工数"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "overage_manager",
      "align": "center",
      "label": "经理"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "overage_executive",
      "align": "center",
      "label": "主管"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "overage_staff",
      "align": "center",
      "label": "员工"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "性别"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "male",
      "align": "center",
      "label": "男"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "female",
      "align": "center",
      "label": "女"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "司龄"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "working_years_1",
      "align": "center",
      "label": "0-1"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "working_years_2",
      "align": "center",
      "label": "1-3"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "working_years_3",
      "align": "center",
      "label": "3-5"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "working_years_4",
      "align": "center",
      "label": "5-10"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "working_years_5",
      "align": "center",
      "label": "10+"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "年龄"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "age_1",
      "align": "center",
      "label": "16-30"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "age_2",
      "align": "center",
      "label": "30-50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "age_3",
      "align": "center",
      "label": "50-65"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "age_4",
      "align": "center",
      "label": "65-70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "age_5",
      "align": "center",
      "label": "70+"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "学历"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "primary_school",
      "align": "center",
      "label": "小学"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "junior_middle_school",
      "align": "center",
      "label": "初中"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "technical_secondary_school",
      "align": "center",
      "label": "中专"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "senior_high_school",
      "align": "center",
      "label": "高中"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "junior_college",
      "align": "center",
      "label": "大专"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "university",
      "align": "center",
      "label": "大学"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-top": "10px",
      "text-align": "center"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "page-size": _vm.page_size,
      "layout": " prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "5px 3% 0px",
      "overflow-y": "hidden",
      "overflow-x": "auto"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "370px",
      "min-width": "1540px"
    }
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid #ccc",
      "width": "35%",
      "height": "370px",
      "float": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-left": "20px",
      "font-weight": "600",
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "4px",
      "height": "20px",
      "margin-right": "8px"
    },
    attrs: {
      "src": require("../../../src/assets/小绿条.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("70岁（含）超龄员工数")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "auto",
      "height": "370px"
    },
    attrs: {
      "id": "main1"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px solid #ccc",
      "width": "30%",
      "height": "370px",
      "float": "left",
      "margin": "0 1%"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-left": "20px",
      "font-weight": "600",
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "4px",
      "height": "20px",
      "margin-right": "8px"
    },
    attrs: {
      "src": require("../../../src/assets/小绿条.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("性别")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "auto",
      "height": "370px"
    },
    attrs: {
      "id": "main2"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px solid #ccc",
      "width": "32.6%",
      "height": "370px",
      "float": "right"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-left": "20px",
      "font-weight": "600",
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "4px",
      "height": "20px",
      "margin-right": "8px"
    },
    attrs: {
      "src": require("../../../src/assets/小绿条.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("司龄")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "auto",
      "height": "370px"
    },
    attrs: {
      "id": "main3"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px solid #ccc",
      "width": "35%",
      "height": "370px",
      "float": "left",
      "margin": "17px 1% 0 0"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-left": "20px",
      "font-weight": "600",
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "4px",
      "height": "20px",
      "margin-right": "8px"
    },
    attrs: {
      "src": require("../../../src/assets/小绿条.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("年龄")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "auto",
      "height": "370px"
    },
    attrs: {
      "id": "main4"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "border": "1px solid #ccc",
      "width": "63.7%",
      "height": "370px",
      "float": "right",
      "margin-top": "17px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "20px",
      "margin-left": "20px",
      "font-weight": "600",
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "4px",
      "height": "20px",
      "margin-right": "8px"
    },
    attrs: {
      "src": require("../../../src/assets/小绿条.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v("学历")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "auto",
      "height": "370px"
    },
    attrs: {
      "id": "main5"
    }
  })])])])
}]
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-93231d5e","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/report/employee_info.vue
// module id = null
// module chunks = 